<template>
    <div class="box-page">
        <div class="col-12 pl-0 pr-0">
            <div class="col-12 pl-0 pr-0 d-md-flex flex-column">
                <div class="col-12 col-md-12 pl-0 pr-0 pr-md-3 d-flex flex-row">
                    <div class="col-12 pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow mr-3">
                        <div class="col-12 pt-3 pb-3 pl-2 pr-2 filter-title cursor-pointer" data-toggle="collapse" data-target="#filterVoucher"
                            @click="toggleFilter" :class="tfilter == true ? 'active' : ''">
                            <div class="col-6 pl-0 mt-auto mb-auto">
                                <div class="col-12 pl-0 pr-0 font-size-10"><span class="mr-2"><i class="fas fa-filter"></i></span>Filter</div>
                            </div>
                        </div>
                        <div id="filterVoucher" class="collapse">
                            <div class="col-12 pb-3 pl-3 pr-3 pl-md-4 pr-md-4 font-size-10">
                                <div class="col-12 pl-0 pr-0 d-md-flex flex-wrap">
                                    <div class="col-12 col-md-4 pl-0 pr-0 pt-2 pt-md-0 d-flex">
                                        <div class="col-3 pl-0 pt-1 font-size-sm-9">Kode Mitra</div>
                                        <div class="col-9 pl-0 pr-0 pr-md-3 d-flex">
                                            <div class="col-12 pl-0 pr-0">
                                                <input v-model="mid.value"
                                                    class="col-12 font-size-9 form-control form-control-sm border rounded-cus box-purple"
                                                    type="text" placeholder="Kode Mitra Ex:GS11111">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4 pl-0 pr-0 pt-2 pt-md-0 d-flex">
                                        <div class="col-3 pl-0 pt-1 font-size-sm-9">Kode Voucher</div>
                                        <div class="col-9 pl-0 pr-0 pr-md-3 d-flex">
                                            <div class="col-12 pl-0 pr-0">
                                                <input v-model="voucher.value"
                                                    class="col-12 font-size-9 form-control form-control-sm border rounded-cus box-purple"
                                                    type="text" placeholder="Kode Voucher">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-8 col-lg-4 pl-0 pr-0 d-flex">
                                        <div class="col-3 pl-0 pt-1 font-size-sm-9">Promo</div>
                                        <div class="col-9 pl-0 pr-0 pr-md-3 d-flex">
                                            <div class="col-12 pl-0 pr-0">
                                                <v-select v-model="promo.value" :options="listPromo" label="name" :reduce="el => el.value"
                                                    class="font-size-9 w-100">
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 pl-0 pr-0 pt-md-2 pt-lg-3 d-flex flex-wrap">
                                    <div class="col-12 col-md-4 pl-0 pr-0 pt-2 pt-md-0 d-flex">
                                        <div class="col-3 pl-0 pt-1 font-size-sm-9">Tanggal Klaim</div>
                                        <div class="col-9 pl-0 pr-0 pr-md-3 d-flex">
                                            <div class="col-6 pl-0 pr-2">
                                                <datetime input-id="tanggalAwal" :max-datetime="maxDate"
                                                    :min-datetime="new Date('2025-01-24').toISOString()" class="theme-purple"
                                                    input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9"
                                                    placeholder="Dari Tanggal" v-model="tanggalAwal"></datetime>
                                            </div>
                                            <div class="col-6 pl-0 pr-0">
                                                <datetime input-id="tanggalAkhir" :max-datetime="today" :min-datetime="minDate"
                                                    class="theme-purple"
                                                    input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9"
                                                    placeholder="Sampai Tanggal" v-model="tanggalAkhir"></datetime>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4 pl-0 pr-0 pl-md-3 pr-md-3 pt-2 pt-md-0 d-flex">
                                        <div class="col-12 pl-0 pr-0 d-flex">
                                            <div class="col-6 pl-0 pr-2">
                                                <button class="col-12 pt-1 pb-1 btn btn-outline-danger rounded-cus no-box-focus">
                                                    <div class="font-size-9" @click="reset">Reset</div>
                                                </button>
                                            </div>
                                            <div class="col-6 pl-2 pr-0">
                                                <button class="col-12 pt-1 pb-1 btn btn-blue rounded-cus no-box-focus">
                                                    <div class="font-size-9" @click="cari">Cari</div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 d-flex pl-0 flex-column flex-md-row">
                    <div class="col-12  pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow mt-3 pb-1">
                        <div class="col-12 pt-3 pb-3 pl-2 pr-2 d-flex">
                            <div class="col-8 col-md-6 pl-0 pb-1 mt-auto mb-auto">
                                <div class="col-12 pl-0 pr-0 font-size-sm-11">Data Klaim Voucher</div>
                            </div>
                        </div>
                        <div class="col-12 pl-0 pr-0 overflow-auto">
                            <div class="col-12 mt-3 pl-2 pr-2 pb-3 d-flex font-size-10">
                                <div class="col-4 col-md-2 col-lg-2 pl-0">Kode Mitra</div>
                                <div class="col-6 col-md-2 col-lg-2 pl-0">Kode Voucher</div>
                                <div class="col-6 col-md-2 col-lg-2 pl-0">Tanggal Klaim</div>
                                <div class="col-6 col-md-2 col-lg-2 pl-0">Promo Dipilih</div>
                                <div class="col-6 col-md-4 col-lg-4 pl-0">Keterangan</div>
                            </div>
                            <div v-show="dataListVoucher.length == 0">
                                <div class="col-12 pt-3 pl-2 pr-2" v-for="(index) in 5" :key="index">
                                    <vcl :width='300' :height='15' class="border-bottom">
                                        <rect x="0" y="2" rx="2" ry="2" width="40" height="7" />
                                        <rect x="50" y="2" rx="2" ry="2" width="40" height="7" />
                                        <rect x="100" y="2" rx="2" ry="2" width="40" height="7" />
                                        <rect x="150" y="2" rx="2" ry="2" width="60" height="7" />
                                        <rect x="225" y="2" rx="2" ry="2" width="60" height="7" />
                                    </vcl>
                                </div>
                            </div>
                            <div class="col-12 pl-0 pr-0" v-if="dataListVoucher == 'error'">
                                <div class="col-12 pt-3 pb-3 text-center">
                                    <div class="col-6 col-md-4 ml-auto mr-auto">
                                        <img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
                                    </div>
                                    <div class="font-size-11 pt-1">Data tidak tersedia!</div>
                                </div>
                            </div>
                            <div class="col-12 pl-0 pr-0" v-else>
                                <div class="col-12 pt-3 pl-2 pr-2 pb-3 d-flex font-size-10" v-for="(value, index) in dataListVoucher"
                                    :key="index">
                                    <div class="col-4 col-md-2 col-lg-2 pl-0">{{ value.voucher_owner_mid }}</div>
                                    <div class="col-6 col-md-2 col-lg-2 pl-0">{{ value.voucher_code }}</div>
                                    <div class="col-6 col-md-2 col-lg-2 pl-0">{{ value.voucher_used_datetime | toTanggal }}</div>
                                    <div class="col-6 col-md-2 col-lg-2 pl-0">{{ promoText(value.voucher_type) }}</div>
                                    <div class="col-6 col-md-4 col-lg-4 pl-0">{{ value.voucher_note }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 pl-2 pr-2">
                            <div class="col-12 border-bottom"></div>
                        </div>
                        <div class="col-12 pt-3 pl-2 pr-2 text-center">
                            <i-pagination :limit='limit' @changeLimit="changeLimit($event)" :pagination='pagination' @gotoPage="gotoPage($event)"
                                @refresh="refresh($event)"></i-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IPagination from '@/components/IPagination.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
    components: {
        IPagination,
    },
    name: 'Report',
    data() {
        return {
            listPromo: [{ value: '', name: 'Semua Promo' }, { value: '1', name: 'Promo MDW 1 Rp.250.000' }, { value: '2', name: 'Promo MDW 2 Rp.400.000' }, { value: '3', name: 'Voucher GERCEP' }],
            tanggalAwal: "",
            tanggalAkhir: "",
            tfilter: false,
            today: new Date().toISOString(),
            limit: 10,
            tanggal: {
                value: '',
                comparison: 'bet',
                type: 'date',
                field: 'voucher_used_datetime'
            },
            mid: {
                value: '',
                comparison: '=',
                type: 'string',
                field: 'voucher_owner_mid'
            },
            voucher: {
                value: '',
                comparison: '=',
                type: 'string',
                field: 'voucher_code'
            },
            promo: {
                value: '',
                comparison: '=',
                type: 'string',
                field: 'voucher_type'
            },
            params: {},
            rangeLaporan: '',
            page: 1
        }
    },
    methods: {
        gotoPage(val) {
            this.page = val
            if (this.params) {
                this.getDataVoucher({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getDataVoucher({ page: this.page, limit: this.limit })
            }
        },
        refresh(val) {
            this.page = val
            if (this.params) {
                this.getDataVoucher({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getDataVoucher({ page: this.page, limit: this.limit })
            }
        },
        changeLimit(val) {
            this.page = 1
            this.limit = val
            if (this.params) {
                this.getDataVoucher({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getDataVoucher({ page: this.page, limit: this.limit })
            }
        },
        cari() {
            this.params = []
            this.page = 1
            if (!this.tanggalAkhir) {
                this.tanggalAkhir = this.tanggalAwal
            }
            if (this.tanggalAkhir == this.tanggalAwal) {
                this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY')
            } else {
                this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY') + ' s.d ' + moment(this.tanggalAkhir).format('Do MMMM YYYY')
            }
            if (this.tanggalAwal && this.tanggalAkhir) {
                this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD') + "::" + moment(this.tanggalAkhir).format('YYYY-MM-DD')
                this.params.push(this.tanggal)
            } else {
                this.rangeLaporan = ''
            }
            if (this.mid.value) {
                this.params.push(this.mid)
            }
            if (this.voucher.value) {
                this.params.push(this.voucher)
            }
            if (this.promo.value) {
                this.params.push(this.promo)
            }
            this.getDataVoucher({ params: this.params, page: this.page, limit: this.limit })
        },
        reset() {
            this.mid.value = ''
            this.voucher.value = ''
            this.promo.value = ''
            this.tanggal.value = ''
            this.rangeLaporan = ''
            this.tanggalAwal = ''
            this.tanggalAkhir = ''
            this.page = 1
            this.params = []
            this.getDataVoucher({ params: this.params, page: this.page, limit: this.limit })
        },
        toggleFilter() {
            if (!this.tfilter) {
                this.tfilter = true;
            } else {
                this.tfilter = false;
            }
        },
        promoText(value) {
            var text = ''
            if (value == 1) {
                text = 'Promo MDW 1 Rp.250.000'
            } else if (value == 2) {
                text = 'Promo MDW 2 Rp.400.000'
            } else if (value == 3) {
                text = 'Voucher GERCEP'
            }

            return text
        },
        ...mapActions('voucherList', ['getDataVoucher']),
    },
    computed: {
        ...mapState('voucherList', ['dataListVoucher', 'pagination']),
        ...mapState('auth', ['userData']),
        ...mapGetters('auth', ['isAuth']),

        minDate() {
            var date = new Date().toISOString()
            if (this.tanggalAwal) {
                date = new Date(this.tanggalAwal).toISOString()
            } else {
                date = this.today
            }
            return date
        },
        maxDate() {
            var date = new Date().toISOString()
            if (this.tanggalAkhir) {
                date = new Date(this.tanggalAkhir).toISOString()
            }
            return date
        }
    },
    created() {
        this.$store.dispatch('setPageTitle', 'List Voucher');
        this.params = []
        if (!this.tanggalAkhir) {
            this.tanggalAkhir = this.tanggalAwal
        }
        if (this.tanggalAkhir == this.tanggalAwal) {
            this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY')
        } else {
            this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY') + ' s.d ' + moment(this.tanggalAkhir).format('Do MMMM YYYY')
        }
        if (this.tanggalAwal && this.tanggalAkhir) {
            this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD') + "::" + moment(this.tanggalAkhir).format('YYYY-MM-DD')
            this.params.push(this.tanggal)
        } else {
            this.rangeLaporan = ''
        }

        this.getDataVoucher({ params: this.params, page: this.page, limit: this.limit })
    }
};
</script>
